import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import predictServices from './predict.services';
import { notification } from 'antd';

export function usePredictLicensePlate() {
  return useMutation({
    mutationFn: predictServices.licensePlate,
    onError(err: AxiosError<{ message?: string }>) {
      notification.error({
        message:
          err.response?.data?.message ||
          'Não foi possível analisar a imagem capturada',
      });
    },
  });
}
